import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { finalize, map } from "rxjs/operators";
import { CommonService } from "../common/common.service";
import { environment } from "../../../../environments/environment";

@Injectable()
export class ApiService {
  baseUrl = environment.apiUrl

  constructor(private http: HttpClient, private commonService: CommonService) {}

  // Manage Group

  commonGetMethod(url: string, queryParams: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.get(endPoint, { params: queryParams }).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPostMethod(url: string, data: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.post(endPoint, data).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPostFormData(url: string, data: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.post(endPoint, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    }).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonDeleteMethod(url: string): Observable<any> {
    this.commonService.startLoading();
    return this.http.delete(this.baseUrl + url).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonUpdateMethod(url: string, body: any, queryParams: any): Observable<any> {
    this.commonService.startLoading();
    return this.http.put(this.baseUrl + url, body, { params: queryParams }).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPatchMethod(url: string, data: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.patch(endPoint, data).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonFlightSearchPostMethod(url: string, data: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.post(endPoint, data).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPostMethodWithoutLoader(url: string, data: any, isKafilaApi?: boolean): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.post(endPoint, data).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPatchMethodWithoutLoader(url: string, data: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.patch(endPoint, data).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonGetMethodWithoutLoader(url: string, queryParams: any): Observable<any> {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.get(endPoint, { params: queryParams }).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }

  commonPostBlobMethod(url: string, data: any) {
    const endPoint = this.baseUrl + url;
    this.commonService.startLoading();
    return this.http.post(endPoint, data, {
      responseType: 'blob',
    }).pipe(
      finalize(() => this.commonService.stopLoading())
    );
  }
}
